'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n\n  ', ';\n'], ['\n  ', ';\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n  ', ';\n'], ['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIPopoverHeader = require('./UIPopoverHeader');

var _UIPopoverHeader2 = _interopRequireDefault(_UIPopoverHeader);

var _UIPopoverBody = require('./UIPopoverBody');

var _UIPopoverBody2 = _interopRequireDefault(_UIPopoverBody);

var _UIPopoverFooter = require('./UIPopoverFooter');

var _UIPopoverFooter2 = _interopRequireDefault(_UIPopoverFooter);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _TwoWayTransition = require('../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _times = require('HubStyleTokens/times');

var _Functions = require('../core/Functions');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _Memoize = require('../core/Memoize');

var _Use = require('./utils/Use');

var _PopoverContext = require('../context/PopoverContext');

var PopoverContext = _interopRequireWildcard(_PopoverContext);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var isReactNode = function isReactNode(node) {
  return (typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object' || _react2.default.isValidElement(node) || Array.isArray(node);
};

var transitionDuration = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var getPopoverClassName = function getPopoverClassName(className, use) {
  return (0, _classNames2.default)(className, _Use.USE_CLASSES[use], 'private-popover', 'uiPopover');
};

var getStyle = function getStyle(style, width) {
  return width ? _extends({
    maxWidth: width,
    width: width
  }, style) : style;
};

var getContext = function getContext(use) {
  return { use: use };
};

var renderArrow = function renderArrow(_ref) {
  var arrowColor = _ref.arrowColor,
      arrowSize = _ref.arrowSize,
      hasStructuredHeader = _ref.hasStructuredHeader,
      hasStructuredFooter = _ref.hasStructuredFooter,
      isStructured = _ref.isStructured,
      placement = _ref.placement,
      use = _ref.use;

  var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[arrowSize];
  return _react2.default.createElement(_UIPopoverArrow2.default, {
    color: arrowColor,
    inset: computedArrowParams.inset,
    key: 'arrow',
    placement: placement,
    width: computedArrowParams.width,
    popoverUse: use,
    hasStructuredHeader: hasStructuredHeader,
    hasStructuredFooter: hasStructuredFooter,
    isStructured: isStructured
  });
};

var renderStructuredContent = function renderStructuredContent(content, placement, arrowProps, onOpenChange, showCloseButton) {
  var header = content.header,
      body = content.body,
      footer = content.footer,
      step = content.step;

  var structuredArrowProps = _extends({}, arrowProps, { isStructured: true });
  var headerArrow = placement.match(/bottom/) ? renderArrow(_extends({}, structuredArrowProps, { hasStructuredHeader: !!header })) : null;
  var bodyArrow = placement.match(/bottom|top/) ? null : renderArrow(structuredArrowProps);
  var footerArrow = placement.match(/top/) ? renderArrow(_extends({}, structuredArrowProps, { hasStructuredFooter: !!footer })) : null;
  return [header ? _react2.default.createElement(
    _UIPopoverHeader2.default,
    {
      key: 'header',
      showCloseButton: showCloseButton,
      onOpenChange: onOpenChange
    },
    header,
    headerArrow
  ) : headerArrow, body ? _react2.default.createElement(
    _UIPopoverBody2.default,
    { key: 'body' },
    body,
    bodyArrow
  ) : bodyArrow, footer || step ? _react2.default.createElement(
    _UIPopoverFooter2.default,
    {
      key: 'footer',
      hasStructuredFooter: !!footer,
      hasStep: !!step
    },
    step,
    footer,
    footerArrow
  ) : footerArrow];
};

var renderContentWithArrow = function renderContentWithArrow(Content, content, placement, arrowProps, onOpenChange, showCloseButton) {
  var renderedContent = Content ? _react2.default.createElement(Content, null) : content;
  /**
   * Throw a warning on:
   * - Content or content that is a node
   * - content is an object that doesn't have a `header`
   */
  if (showCloseButton && (isReactNode(renderedContent) || !renderedContent.header)) {
    _devLogger2.default.warn({
      message: 'UIPopover: `showCloseButton={true}` requires you to provide the `content` prop as an object with a `header`.',
      key: 'UIPopover: showCloseButton'
    });
  }
  return isReactNode(renderedContent) ? [renderArrow(arrowProps), _react2.default.createElement(
    'div',
    { className: 'private-popover__inner', key: 'content' },
    renderedContent
  )] : renderStructuredContent(renderedContent, placement, arrowProps, onOpenChange, showCloseButton);
};

var transformOriginMixin = (0, _styledComponents.css)(_templateObject, ['top', 'bottom', 'left', 'right'].map(function (side) {
  return '.tether-element-attached-' + side + ' & { transform-origin: ' + side + ' }';
}), ['top', 'bottom'].map(function (ySide) {
  return ['left', 'right'].map(function (xSide) {
    return '.tether-element-attached-' + ySide + '.tether-element-attached-' + xSide + ' & { transform-origin: ' + ySide + ' ' + xSide + ' }';
  });
}));

var PopoverTransitionWrapper = (0, _styledComponents2.default)(_TwoWayTransition2.default.PlainWrapper).withConfig({
  displayName: 'UIPopoverContent__PopoverTransitionWrapper'
})(_templateObject2, function (_ref2) {
  var transitioning = _ref2.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref3) {
  var duration = _ref3.duration;
  return duration;
}, function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden ? '0' : '1';
}, function (_ref5) {
  var hidden = _ref5.hidden,
      transitioning = _ref5.transitioning;

  if (!hidden && !transitioning) return 'none'; /* IE bugfix: #5368 */
  return hidden ? 'scale(.75)' : 'scale(1)';
}, transformOriginMixin);

var UIPopoverContent = function (_React$Component) {
  _inherits(UIPopoverContent, _React$Component);

  function UIPopoverContent(props) {
    _classCallCheck(this, UIPopoverContent);

    var _this = _possibleConstructorReturn(this, (UIPopoverContent.__proto__ || Object.getPrototypeOf(UIPopoverContent)).call(this, props));

    _this.state = {
      openComplete: props.open && !props.animateOnMount
    };
    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    _this._getContext = (0, _Memoize.memoizeLastResult)(getContext);
    _this.handleOpenComplete = _this.handleOpenComplete.bind(_this);
    _this.handleCloseStart = _this.handleCloseStart.bind(_this);
    return _this;
  }

  _createClass(UIPopoverContent, [{
    key: 'handleOpenComplete',
    value: function handleOpenComplete() {
      var onOpenComplete = this.props.onOpenComplete;

      this.setState({ openComplete: true });
      (0, _Functions.callIfPossible)(onOpenComplete);
    }
  }, {
    key: 'handleCloseStart',
    value: function handleCloseStart() {
      var onCloseStart = this.props.onCloseStart;

      this.setState({ openComplete: false });
      (0, _Functions.callIfPossible)(onCloseStart);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animateOnMount = _props.animateOnMount,
          animateOnToggle = _props.animateOnToggle,
          arrowColor = _props.arrowColor,
          arrowSize = _props.arrowSize,
          className = _props.className,
          content = _props.content,
          Content = _props.Content,
          onCloseComplete = _props.onCloseComplete,
          __onCloseStart = _props.onCloseStart,
          __onOpenComplete = _props.onOpenComplete,
          onOpenStart = _props.onOpenStart,
          open = _props.open,
          placement = _props.placement,
          style = _props.style,
          use = _props.use,
          showCloseButton = _props.showCloseButton,
          onOpenChange = _props.onOpenChange,
          width = _props.width,
          rest = _objectWithoutProperties(_props, ['animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'className', 'content', 'Content', 'onCloseComplete', 'onCloseStart', 'onOpenComplete', 'onOpenStart', 'open', 'placement', 'style', 'use', 'showCloseButton', 'onOpenChange', 'width']);

      var openComplete = this.state.openComplete;


      var computedOpen = open && (Content || content);

      var renderedContent = computedOpen ? _react2.default.createElement(
        PopoverContext.Provider,
        { value: this._getContext(use) },
        _react2.default.createElement(
          'div',
          _extends({
            className: getPopoverClassName(className, use),
            'data-open-complete': openComplete,
            style: this._getStyle(style, width)
          }, rest),
          renderContentWithArrow(Content, content, placement, {
            arrowColor: arrowColor,
            arrowSize: arrowSize,
            placement: placement,
            use: use
          }, onOpenChange, showCloseButton)
        )
      ) : null;

      return _react2.default.createElement(
        _TwoWayTransition2.default,
        {
          onCloseComplete: onCloseComplete,
          onCloseStart: this.handleCloseStart,
          onOpenComplete: this.handleOpenComplete,
          onOpenStart: onOpenStart,
          transitionOnMount: animateOnMount,
          duration: animateOnToggle ? transitionDuration : 0,
          Wrapper: PopoverTransitionWrapper
        },
        renderedContent
      );
    }
  }]);

  return UIPopoverContent;
}(_react2.default.Component);

UIPopoverContent.propTypes = {
  animateOnMount: _react.PropTypes.bool.isRequired,
  animateOnToggle: _react.PropTypes.bool,
  arrowColor: _react.PropTypes.string,
  arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)).isRequired,

  content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
    header: _react.PropTypes.node,
    body: _react.PropTypes.node,
    footer: _react.PropTypes.node
  })]),
  Content: _component2.default,
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  showCloseButton: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES)),
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};

UIPopoverContent.defaultProps = {
  animateOnMount: false,
  open: false,
  placement: 'top',
  use: 'default'
};

UIPopoverContent.displayName = 'UIPopoverContent';

exports.default = UIPopoverContent;
module.exports = exports['default'];